import api from 'api/apiInstance';

export function documentPackDocumentViewApi(path: string) {
  return {
    path,
    PATCH: () => api.patch(path),
  };
}
